module.exports = __webpack_public_path__ + "static/img/en-US.83bc1d7d.svg";